type DownloadStepKind = 'password' | 'provider' | 'fallback'

interface DownloadStep {
  kind: DownloadStepKind
  email?: string
  provider?: 'Apple' | 'Google'
}

export function getDownloadStepThreeHint(providerId?: IAuthMethod | string | null, email?: string | null): DownloadStep {
  const normalizedEmail = email?.trim()

  if (providerId === 'password' && normalizedEmail) {
    return {
      kind: 'password',
      email: normalizedEmail
    }
  }

  if (providerId === 'google.com') {
    return {
      kind: 'provider',
      provider: 'Google',
      email: normalizedEmail
    }
  }

  if (providerId === 'apple.com') {
    return {
      kind: 'provider',
      provider: 'Apple',
      email: normalizedEmail
    }
  }

  return {
    kind: 'fallback'
  }
}
